import { ConfigKeys } from "./types/Config";
import { AttributeKey } from "./types/ConfigAttribute";

const API_BASE_URL = "/api";

export interface ConfigAttribute {
  attribute_key: AttributeKey;
  attribute_name: string;
  attribute_value: string;
}

export interface Config {
  id: number;
  key: ConfigKeys;
  name: string;
  attributes: ConfigAttribute[];
}

export const api = {
  getAllConfigs: async (): Promise<any> => {
    const token = localStorage.getItem("token");

    const response = await fetch(`${API_BASE_URL}/config`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch configurations");
    }
    return response.json();
  },

  getConfigByKey: async (key: ConfigKeys): Promise<Config> => {
    const response = await fetch(`${API_BASE_URL}/configs/${key}`);
    if (!response.ok) {
      throw new Error("Failed to fetch configuration");
    }
    return response.json();
  },

  saveConfig: async (config: Omit<Config, "id">): Promise<Config> => {
    const response = await fetch(`${API_BASE_URL}/configs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(config),
    });
    if (!response.ok) {
      throw new Error("Failed to save configuration");
    }
    return response.json();
  },

  deleteConfig: async (key: ConfigKeys): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/configs/${key}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      throw new Error("Failed to delete configuration");
    }
  },
};
